import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/catalogue/')({
  beforeLoad: () => {
    throw redirect({ to: '/catalogue/$kind', params: { kind: 'categories' }, replace: true })
  },
})
